import { render, staticRenderFns } from "./UnidadeNegocioConfiguracionList.vue?vue&type=template&id=42b68e4e"
import script from "./UnidadeNegocioConfiguracionList.vue?vue&type=script&lang=js"
export * from "./UnidadeNegocioConfiguracionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports